export default {
  notAvailable: 'Momentálne nedostupné.',
  noServices: 'Táto spoločnosť neposkytuje zatiaľ žiadne služby.',
  noGalleryImages: 'Žiadne obrázky na zobrazenie. Nahrať ich môžete stlačením tlačidla "NAHRAŤ".',
  unexpectedError: 'Niečo sa pokazilo. Prosíme, skúste svoju akciu opakovať.',
  emailNotConfirmed: {
    header: 'Váš email nie je overený.',
    message: 'Skontrolujte, prosím Vašu emailovú schránku. Pokiaľ Vám nebol doručený overovací email, môžete si požiadať o opätovné zaslanie.'
  },
  addCompany: {
    emailNotVerified: 'Pre pridanie spoločnosti musíte overiť svoj email.'
  },
  login: {
    badCredentials: 'Nesprávne prihlasovacie údaje.'
  },
  register: {
    alreadyExists: 'Účet s týmto emailom už existuje.',
    notValidEmailOrPassword: 'Email alebo heslo je v nesprávnom tvare.',
    passwordsDontMatch: 'Heslá sa nezhodujú.'
  },
  resetPassword: {
    emailNotValid: 'Zadaný email nie je správny.'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/sk/errors.js